/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/** 
  All of the routes for the Material Dashboard 2 React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that has other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

// Material Dashboard 2 React layouts
import Dashboard from "layouts/dashboard";
import AddUser from "layouts/AddUser";
import Tables from "layouts/tables";
import Inquiry from "layouts/Inquiry";
import RenewApp from "layouts/renewApp";
import SpecialDays from "layouts/specialDay";
import Holidays from "layouts/HolidayOff";
import Profile from "layouts/profile";
import ProfileEdit from "layouts/profileEdit";
import AddSpecialDay from "layouts/addSpecialDay";
import AddHoliday from "layouts/addHoliday";
import AddPCHBooking from "layouts/addPCHBooking";
import ManagePressConfHall from "layouts/managePressConfHall";
import Bookings from "layouts/booking";
import ViewPCHBooking from "layouts/viewPCHBooking";
import ViewCanceledBooking from "layouts/viewCanceledBooking";
import EditPCHBooking from "layouts/editPCHBooking"
import CanceledBookings from "layouts/canceledBookings"
import Logs from "layouts/Logs"


import SignIn from "layouts/authentication/sign-in";
import SignUp from "layouts/authentication/sign-up";

// @mui icons
import Icon from "@mui/material/Icon";
import SpeakerNotesIcon from "@mui/icons-material/SpeakerNotes";
import ThreePIcon from "@mui/icons-material/ThreeP";
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import CancelIcon from '@mui/icons-material/Cancel';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';

const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    // bgColor : "magenta",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: <Dashboard />,
  },
  {
    type: "collapse",
    name: "Bookings",
    // bgColor : "red",
    key: "Bookings",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/Bookings",
    component: <Bookings />,
  },
  {
    type: "collapse",
    name: "Cancel Bookings",
    // bgColor : "red",
    key: "canceledBookings",
    icon: <Icon fontSize="small"><CancelIcon/></Icon>,
    route: "/canceledBookings",
    component: <CanceledBookings />,
  },
  {
    type: "collapse",
    name: "Special Days",
    // bgColor : "red",
    key: "SpecialDays",
    icon: <Icon fontSize="small"><CalendarMonthIcon/></Icon>,
    route: "/SpecialDays",
    component: <SpecialDays />,
  },
  {
    type: "collapse",
    name: "Holidays",
    // bgColor : "red",
    key: "Holidays",
    icon: <Icon fontSize="small"><CalendarMonthIcon/></Icon>,
    route: "/Holidays",
    component: <Holidays />,
  },
  // {
  //   type: "",
  //   name: "Add Cage",
  //   key: "Add Cage",
  //   icon: <Icon fontSize="small">table_view</Icon>,
  //   route: "/AddCage",
  //   component: <AddCage />,
  // },
  {
    type: "",
    name: "Add Member",
    key: "Add Member",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/addMember",
    component: <AddUser />,
  },
  {
    type: "",
    name: "View PCH Booking",
    key: "View PCH Booking",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/viewPCHBooking",
    component: <ViewPCHBooking />,
  },
  {
    type: "",
    name: "View Canceled Booking",
    key: "View Canceled Booking",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/viewCanceledBooking",
    component: <ViewCanceledBooking />,
  },
  {
    type: "",
    name: "Edit PCH Booking",
    key: "Edit PCH Booking",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/editPCHBooking",
    component: <EditPCHBooking />,
  },
  {
    type: "",
    name: "Add Press Conference Booking",
    key: "AddPCHBooking",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/addPCHBooking",
    component: <AddPCHBooking />,
  },
  {
    type: "",
    name: "Add Special Day",
    key: "addSpecialDay",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/addSpecialDay",
    component: <AddSpecialDay />,
  },
  {
    type: "",
    name: "Add Holiday",
    key: "addSpecialDay",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/addHoliday",
    component: <AddHoliday />,
  },
  {
    type: "",
    name: "Manage Press Conference Hall",
    key: "managePressConfHall",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/managePressConfHall",
    component: <ManagePressConfHall />,
  },
  {
    type: "collapse",
    name: "Members",
    // bgColor : "red",
    key: "Members",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/Members",
    component: <Tables />,
  },
  {
    type: "collapse",
    name: "Member Inquiry",
    // bgColor : "red",
    key: "MemberInquiry",
    icon: <ThreePIcon />,
    route: "/MemberInquiry",
    component: <Inquiry />,
  },
  {
    type: "collapse",
    name: "Renew Application",
    // bgColor : "red",
    key: "RenewApplication",
    icon: <Icon fontSize="small"><AutorenewIcon/></Icon>,
    route: "/RenewApplication",
    component: <RenewApp />,
  },

  // {
  //   type: "collapse",
  //   name: "Cages",
  //   // bgColor : "orange",
  //   key: "Cages",
  //   icon: <Icon fontSize="small">receipt_long</Icon>,
  //   route: "/Cages",
  //   component: <Billing />,
  // },
  // {
  //   type: "collapse",
  //   name: "RTL",
  //   key: "rtl",
  //   icon: <Icon fontSize="small">format_textdirection_r_to_l</Icon>,
  //   route: "/rtl",
  //   component: <RTL />,
  // },
  // {
  //   type: "collapse",
  //   name: "Reports",
  //   // bgColor : "green",
  //   key: "Filters",
  //   icon: <Icon fontSize="small">downloads</Icon>,
  //   route: "/Filters",
  //   component: <Notifications />,
  // },
  // {
  //   type: "collapse",
  //   name: "Actions",
  //   key: "Actions",
  //   // bgColor : "violet",
  //   icon: <ThreePIcon />,
  //   route: "/Actions",
  //   component: <Actions />,
  // },
  // {
  //   type: "collapse",
  //   name: "Cage Activities",
  //   // bgColor : "blue",
  //   key: "cage_activities",
  //   icon: <SpeakerNotesIcon />,
  //   route: "/cage_activities",
  //   component: <CageActivities />,
  // },
  {
    type: "",
    name: "",
    key: "profile",
    icon: <Icon fontSize="small"></Icon>,
    route: "/profile",
    component: <Profile />,
  },
  // {
  //   type: "",
  //   name: "",
  //   key: "CageProfile",
  //   icon: <Icon fontSize="small"></Icon>,
  //   route: "/CageProfile",
  //   component: <CageProfile />,
  // },
  // {
  //   type: "",
  //   name: "",
  //   key: "CageProfileEdit",
  //   icon: <Icon fontSize="small"></Icon>,
  //   route: "/CageProfileEdit",
  //   component: <CageProfileEdit />,
  // },
  {
    type: "",
    name: "",
    key: "ProfileEdit",
    icon: <Icon fontSize="small"></Icon>,
    route: "/ProfileEdit",
    component: <ProfileEdit />,
  },

  {
    type: "collapse",
    name: "Sign In",
    key: "sign-in",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/authentication/sign-in",
    component: <SignIn />,
  },
  {
    type: "collapse",
    name: "Logs",
    // bgColor : "red",
    key: "Logs",
    icon: <Icon fontSize="small"><AccessTimeIcon/></Icon>,
    route: "/Logs",
    component: <Logs />,
  },
  // {
  //   type: "collapse",
  //   name: "Sign Up",
  //   key: "sign-up",
  //   icon: <Icon fontSize="small">assignment</Icon>,
  //   route: "/authentication/sign-up",
  //   component: <SignUp />,
  // },
];

export default routes;
